import {
  categoryOptions,
  certaintyOptions,
  responseTypeOptions,
  scopeOptions,
  severityOptions,
  statusOptions,
  urgencyOptions,
} from '../components/IpawsAlertFields/config/Ipaws.config';

const fallbackOptions = {
  status: statusOptions,
  scope: scopeOptions,
  category: categoryOptions,
  responseType: responseTypeOptions,
  urgency: urgencyOptions,
  severity: severityOptions,
  certainty: certaintyOptions,
};

const collectStringEnums = (value, values = new Set()) => {
  if (!value || typeof value !== 'object') return values;
  if (Array.isArray(value.enum)) {
    value.enum.filter((item) => typeof item === 'string').forEach((item) => values.add(item));
  }
  Object.values(value).forEach((child) => collectStringEnums(child, values));
  return values;
};

const collectPropertyEnums = (value, enumValues = new Map()) => {
  if (!value || typeof value !== 'object') return enumValues;

  if (!Array.isArray(value) && value.properties && typeof value.properties === 'object') {
    Object.entries(value.properties).forEach(([propertyName, propertySchema]) => {
      const current = enumValues.get(propertyName) ?? new Set();
      collectStringEnums(propertySchema, current);
      if (current.size) enumValues.set(propertyName, current);
    });
  }

  Object.values(value).forEach((child) => collectPropertyEnums(child, enumValues));
  return enumValues;
};

const optionsFor = (propertyName, enumValues) => {
  const contractValues = enumValues.get(propertyName);
  if (!contractValues?.size) return fallbackOptions[propertyName];

  const labels = new Map(
    fallbackOptions[propertyName].map((option) => [option.value, option.label]),
  );
  const fallbackByValue = new Map(
    fallbackOptions[propertyName].map((option) => [option.value, option]),
  );
  return [...contractValues].map((value) => ({
    ...fallbackByValue.get(value),
    value,
    label: labels.get(value) ?? value,
  }));
};

/**
 * Converts the backend JSON Schema into the option arrays the existing form components consume.
 * A missing or unfamiliar schema falls back to the reviewed local lists. Status remains the local
 * Test-only policy until the COG-scoped `/meta` contract supplies its allowed statuses.
 */
export const getFemaSubmissionContractOptions = (contract) => {
  const enumValues = collectPropertyEnums(contract?.schema);

  return {
    status: statusOptions,
    scope: optionsFor('scope', enumValues),
    category: optionsFor('category', enumValues),
    responseType: optionsFor('responseType', enumValues),
    urgency: optionsFor('urgency', enumValues),
    severity: optionsFor('severity', enumValues),
    certainty: optionsFor('certainty', enumValues),
  };
};
